import useCommonIndustry from "hooks/useCommonIndustry"
import { searchState } from "./states"
import { useRecoilState } from "recoil"
import { LayerBottom, Button } from "components"

const FilterLayer = ({ show, closeLayer, period }) => {

    const industries = useCommonIndustry()
    const [searchParam, setSearchParam] = useRecoilState(searchState)

    return (
        <LayerBottom title="필터" show={show} closeLayer={closeLayer} outside={
            <div className="button-group">
                <Button className="btn btn--big btn-layer" onClick={closeLayer}>확인</Button>
            </div>
        }>
            <ul className="filter-option">
                <li>
                    <p>조회기간</p>
                    <ul className="opt-menu mt_10">
                        {
                            period && period.map((item, index) => {
                                return (
                                    <li key={index} onClick={() => setSearchParam(prev => ({ ...prev, period: item.value }))} className={searchParam.period === item.value ? "active" : undefined}>{item.key}</li>
                                )
                            })
                        }
                        {/* <li onClick={() => setSearchParam(prev => ({ ...prev, period: 1 }))} className={searchParam.period === 1 ? "active" : undefined}>1개월</li>
                        <li onClick={() => setSearchParam(prev => ({ ...prev, period: 3 }))} className={searchParam.period === 3 ? "active" : undefined}>3개월</li>
                        <li onClick={() => setSearchParam(prev => ({ ...prev, period: 6 }))} className={searchParam.period === 6 ? "active" : undefined}>6개월</li>
                        <li onClick={() => setSearchParam(prev => ({ ...prev, period: 0 }))} className={searchParam.period === 0 ? "active" : undefined}>직접설정</li> */}
                    </ul>
                    {
                        searchParam.period === 0 &&
                        <div className="flex-align_center mt_10">
                            <input type="date" defaultValue={searchParam.stDe} onChange={e => setSearchParam(prev => ({ ...prev, stDe: e.target.value }))} />
                            <span style={{ margin: "0 0.5rem" }}>-</span>
                            <input type="date" defaultValue={searchParam.edDe} onChange={e => setSearchParam(prev => ({ ...prev, edDe: e.target.value }))} />
                        </div>
                    }
                </li>
                <li>
                    <p>유형 선택</p>
                    <ul className="opt-menu mt_10">
                        <li onClick={() => setSearchParam(prev => ({ ...prev, type: "" }))} className={searchParam.type === "" ? "active" : undefined}>전체</li>
                        <li onClick={() => setSearchParam(prev => ({ ...prev, type: "CLCT" }))} className={searchParam.type === "CLCT" ? "active" : undefined}>수집</li>
                        <li onClick={() => setSearchParam(prev => ({ ...prev, type: "CHNG" }))} className={searchParam.type === "CHNG" ? "active" : undefined}>변경</li>
                        <li onClick={() => setSearchParam(prev => ({ ...prev, type: "EXPND" }))} className={searchParam.type === "EXPND" ? "active" : undefined}>종료시점 연장</li>
                        <li onClick={() => setSearchParam(prev => ({ ...prev, type: "WTHDR" }))} className={searchParam.type === "WTHDR" ? "active" : undefined}>연결해제</li>
                        <li onClick={() => setSearchParam(prev => ({ ...prev, type: "DEL" }))} className={searchParam.type === "DEL" ? "active" : undefined}>삭제</li>
                    </ul>
                </li>
                <li>
                    <p>업권선택</p>
                    <ul className="opt-menu mt_10">
                        <li onClick={() => setSearchParam(prev => ({ ...prev, industry: "" }))} className={searchParam.industry === "" ? "active" : undefined}>전체</li>
                        {
                            industries &&
                            industries.map((item, index) => {
                                return (
                                    <li onClick={() => setSearchParam(prev => ({ ...prev, industry: item.commCd }))} key={index} className={searchParam.industry === item.commCd ? "active" : undefined}>{item.commNm}</li>
                                )
                            })
                        }
                    </ul>
                </li>
            </ul>
        </LayerBottom>
    )
}

export default FilterLayer